import React from 'react';
import Answer from './Answer';
import { FeatureContainer } from '../../molecules/Containers/FeatureContainer';
import { ButtonWithText } from '../../atoms/Buttons/ButtonWithText';
import { red } from '../../../theme/colors';
import useStyle from './quizGame.style';
import useGoToPage from '../../../hooks/useGoToPage';
import pages from '../../../routes/pages';
import { useDispatch } from 'react-redux';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { resetQuiz } from '../../../store/actions/quiz.action';

const QuizGame = ({ question, next, load, remainingQuestions }) => {
  const classes = useStyle();
  const goToQuizList = useGoToPage(pages.QUIZ_PAGE.path);
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(resetQuiz());
    goToQuizList();
  };
  return (
    <>
      <div className={classes.btnContainer}>
        <ButtonWithText
          content={'Quitter le quiz'}
          onClick={onClick}
          variant="danger"
          icon="Close"
          iconColor={red}
        />
      </div>
      <FeatureContainer>
        <p style={{ margin: 'auto' }}>{remainingQuestions}</p>
        <h2 style={{ margin: 'auto' }}>{question.name}</h2>
      </FeatureContainer>
      <div>
        {load ? (
          <div className={classes.loadingContainer}>
            <LoadingContainer />
          </div>
        ) : (
          <div className={classes.root}>
            <Answer
              response={question.reponse1}
              onClick={() =>
                next(
                  { question: question.name, id: question.id },
                  { reponseName: question.reponse1, reponseNumber: 1 }
                )
              }
              backgroundColor={'blue'}
            />
            <Answer
              response={question.reponse2}
              onClick={() =>
                next(
                  { question: question.name, id: question.id },
                  { reponseName: question.reponse2, reponseNumber: 2 }
                )
              }
              backgroundColor={'violet'}
            />
            <Answer
              response={question.reponse3}
              onClick={() =>
                next(
                  { question: question.name, id: question.id },
                  { reponseName: question.reponse3, reponseNumber: 3 }
                )
              }
              backgroundColor={'orange'}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default QuizGame;
